// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  VehicleDeviceManagementAreaId,
  VehicleDeviceManagementAreaRoutes,
} from '@backoffice-frontend/common'
import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import { VehicleDeviceManagementAreaNavigation } from './VehicleDeviceManagementAreaNavigation'

const LazyVehicleDeviceManagementComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./VehicleDeviceManagementArea')),
)

const VehicleDeviceManagementComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleDeviceManagementComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleDeviceManagementArea = {
  id: VehicleDeviceManagementAreaId,
  requiredRight: BoumRight.AREA_VEHICLE_DEVICE_MANAGEMENT,
  NavigationComponent: VehicleDeviceManagementAreaNavigation,
  route: {
    path: VehicleDeviceManagementAreaRoutes.route,
    component: VehicleDeviceManagementComponent,
  },
}
